import { render, staticRenderFns } from "./AddBoost.vue?vue&type=template&id=16922db9"
import script from "./AddBoost.vue?vue&type=script&lang=js"
export * from "./AddBoost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports